import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { LayoutDashboard, Target, Clock, BookOpen, Menu, AlertTriangle, Link2, CalendarRange, Building2 } from "lucide-react";
import Sidebar, { type SidebarGroup } from "./components/ui/Sidebar";
import { supabase } from "./lib/supabase";

export default function App() {
  const [pendingCount, setPendingCount] = useState<number>(0);
  const [alertsCount, setAlertsCount] = useState<number>(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    let cancel = false;
    const load = async () => {
      const [decRes, alRes] = await Promise.all([
        supabase.from("ads_decisions").select("id", { count: "exact", head: true }).eq("status", "pending"),
        supabase.from("ads_alerts").select("id", { count: "exact", head: true }).eq("status", "open"),
      ]);
      if (!cancel) {
        setPendingCount(decRes.count ?? 0);
        setAlertsCount(alRes.count ?? 0);
      }
    };
    load();
    const ch1 = supabase.channel("ads_decisions_changes").on("postgres_changes", { event: "*", schema: "public", table: "ads_decisions" }, load).subscribe();
    const ch2 = supabase.channel("ads_alerts_changes").on("postgres_changes", { event: "*", schema: "public", table: "ads_alerts" }, load).subscribe();
    return () => { cancel = true; ch1.unsubscribe(); ch2.unsubscribe(); };
  }, []);

  const groups: SidebarGroup[] = [
    {
      label: "Overview",
      items: [
        { id: "overview", label: "Visão geral", icon: <LayoutDashboard size={16} strokeWidth={2} />, to: "/overview" },
        { id: "campaigns", label: "Campanhas", icon: <Target size={16} strokeWidth={2} />, to: "/campaigns" },
        { id: "utms", label: "UTMs", icon: <Link2 size={16} strokeWidth={2} />, to: "/utms" },
      ],
    },
    {
      label: "Planejamento",
      items: [
        { id: "timeline", label: "Timeline", icon: <CalendarRange size={16} strokeWidth={2} />, to: "/timeline" },
      ],
    },
    {
      label: "Comercial",
      items: [
        { id: "leads-comercial", label: "Leads Comercial", icon: <Building2 size={16} strokeWidth={2} />, to: "/leads-comercial" },
      ],
    },
    {
      label: "Agente",
      items: [
        { id: "pending", label: "Pendentes", icon: <Clock size={16} strokeWidth={2} />, to: "/pending", count: pendingCount },
        { id: "alerts", label: "Alertas", icon: <AlertTriangle size={16} strokeWidth={2} />, to: "/alerts", count: alertsCount },
        { id: "history", label: "Histórico", icon: <BookOpen size={16} strokeWidth={2} />, to: "/history" },
      ],
    },
  ];

  return (
    <div className="flex min-h-screen bg-esm-gray-50 font-sans">
      <Sidebar groups={groups} mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="sticky top-0 z-30 bg-white border-b border-esm-gray-100 px-4 py-2.5 flex items-center gap-3 shadow-sm lg:hidden">
          <button
            onClick={() => setMobileOpen(true)}
            className="p-2 rounded-lg text-esm-gray-400 hover:text-esm-gray-700 hover:bg-esm-gray-50 border border-esm-gray-200 transition-colors flex-shrink-0"
          >
            <Menu size={18} />
          </button>
          <div className="text-sm font-bold text-esm-gray-900">EPH Ads Pipeline</div>
        </div>
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-5 sm:py-7">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
